import React from 'react';
import FeatureFlag from 'yoda-core-components/lib/components/FeatureFlag/FeatureFlag';
import MiniPDPInterstitialAsync from 'yoda-mini-pdp/lib/components/MiniPDPInterstitial/MiniPDPInterstitialAsync';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';

/* istanbul ignore next */
const renderMiniPDP = () => (
    <FeatureFlag name="enableMiniPDPFeature">
        <Loading />
        <MiniPDPInterstitialAsync />
    </FeatureFlag>
);
export default renderMiniPDP;
